import React from 'react';
import clsx from 'clsx';
import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import IconRenderer from '../../../../../../../../global/react-mui/atoms/IconRenderer';
import { useSelector } from 'react-redux';
import { partnerCategoriesSelector } from '../../../store/modules/filters/selectors';

type CategoryToggleFilterTypes = {
	handleOnChange: (value: any) => void;
	selected: string[];
};

const CategoryToggleFilter: React.FC<CategoryToggleFilterTypes> = ({ handleOnChange, selected }) => {
	const classes = useStyles();
	const partnerCategories = useSelector(partnerCategoriesSelector);
	return (
		<Grid container>
			{partnerCategories.map((category) => (
				<Grid item className={classes.container} key={category.label} xs={6} md={4}>
					<button
						className={clsx(classes.button, {
							[classes.buttonSelected]: selected.includes(category.value),
						})}
						onClick={() => handleOnChange(category.value)}>
						<Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%">
							<IconRenderer icon={category.icon} shape="squared" bgColor="#E0E0E0" color="#A7A7A7" boxProps={{ marginRight: '8px' }} />
							<Typography className={classes.categoryName} color="textSecondary">
								{category.label}
							</Typography>
						</Box>
					</button>
				</Grid>
			))}
		</Grid>
	);
};
export default CategoryToggleFilter;

const useStyles = makeStyles((theme) => ({
	container: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	button: {
		width: 'calc(100% - 32px)',
		borderRadius: 10,
		backgroundColor: 'transparent',
		color: '#0D5055',
		border: '1px solid #86A7AA',
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
		margin: theme.spacing(1),
		cursor: 'pointer',
	},
	buttonSelected: {
		backgroundColor: theme.palette.primary.main,
		border: `1px solid ${theme.palette.primary.main}`,
		'& p': {
			color: theme.palette.common.white,
		},
		'& div > div': {
			backgroundColor: theme.palette.common.white,
		},
		'& svg': {
			fill: theme.palette.primary.main,
		},
	},
	categoryName: {
		marginTop: 8,
	},
}));
